module.exports = __webpack_public_path__ + "img/15csm_Ersa-VERSAFLOW-ONE-02-1920x540_6aecf553cb.9f3e4b16.jpg";